(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfred-product-demo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pelsfred-product-demo'))customElements.define('pelsfred-product-demo',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.stage=this.querySelector('.pfd__stage');this.cards=[...this.querySelectorAll('.pfd__slide')];this.count=this.cards.length;if(!this.count)return;
  this.selected=Math.max(0,this.cards.findIndex(c=>c.dataset.current==='true'));this.heading=this.querySelector('h2');this.text=this.querySelector('.pfd__text');this.initialHeading=this.heading.textContent;this.initialText=this.text.innerHTML;this.initial=this.selected;
  this.ghosts=this.cards.map(card=>{const ghost=card.cloneNode(true);ghost.classList.add('pfd__ghost');ghost.removeAttribute('data-current');ghost.removeAttribute('data-shopify-editor-block');ghost.querySelector('video')?.remove();ghost.querySelector('.pfd__play')?.remove();ghost.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));this.stage.append(ghost);return ghost;});
  this.addEventListener('click',e=>{if(this.swiped)return;const arrow=e.target.closest('[data-step]');if(arrow){this.move(Number(arrow.dataset.step));return;}const card=e.target.closest('[data-index]');if(!card)return;const i=Number(card.dataset.index);if(i!==this.selected){const delta=(i-this.selected+this.count)%this.count;if(delta===1)this.move(1);else if(delta===this.count-1)this.move(-1);else{this.finish();this.pause();this.selected=i;this.layout();}return;}if(e.target.closest('.pfd__play'))this.play(this.cards[i]);},opts);
  this.stage.addEventListener('keydown',e=>{if(e.target!==this.stage)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1,true);}},opts);
  this.stage.addEventListener('dragstart',e=>e.preventDefault(),opts);
  this.stage.addEventListener('pointerdown',e=>{if(e.target.closest('video')||e.target.closest('.pfd__play'))return;this.touch={x:e.clientX,y:e.clientY};},opts);
  this.stage.addEventListener('pointerup',e=>{if(!this.touch)return;const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>38&&Math.abs(dx)>Math.abs(dy)*1.3){this.move(dx>0?1:-1);this.swiped=true;setTimeout(()=>this.swiped=false,0);}},opts);
  this.stage.addEventListener('pointercancel',()=>this.touch=null,opts);
  this.cards.forEach(c=>{const v=c.querySelector('video');if(v){v.addEventListener('ended',()=>{delete c.dataset.playing;v.controls=false;},opts);v.addEventListener('error',()=>{delete c.dataset.playing;v.controls=false;this.querySelector('.pfd__status').textContent=this.dataset.error;},opts);}});
  this.resize=new ResizeObserver(()=>{this.finish();this.layout();});this.resize.observe(this.stage);this.layout();
 }
 distance(i){let d=(i-this.selected+this.count)%this.count;if(d>this.count/2)d-=this.count;return d;}
 duplicateDistance(d){return d<0?d+this.count:d-this.count;}
 layout(){const w=this.stage.clientWidth;this.sides=innerWidth<750?1:2;this.cardWidth=Math.min(this.sides===1?240:280,w*(this.sides===1?.64:.44));this.height=this.cardWidth*16/9;const edgeScale=this.sides===1?.77:.64;this.step=(w-this.cardWidth*edgeScale)/(this.sides*2);this.stage.style.setProperty('--pfd-width',this.cardWidth+'px');this.stage.style.setProperty('--pfd-height',this.height+'px');this.render(false);this.copy();}
 place(c,d,animate){const a=Math.abs(d),scale=a===0?1:a===1?.77:.64;let x=(this.stage.clientWidth-this.cardWidth*scale)/2-d*this.step;if(a>this.sides)x=d>0?-this.cardWidth-20:this.stage.clientWidth+20;const y=-(this.height-this.height*scale)/2;c.style.transitionDuration=animate?'220ms':'0ms';c.style.transform=`translate(${x}px,${y}px) scale(${scale})`;c.style.zIndex=String(10-a);const visible=a<=this.sides;c.setAttribute('aria-hidden',String(!visible));c.style.pointerEvents=visible?'':'none';const select=c.querySelector('.pfd__select');select.tabIndex=visible&&a!==0?0:-1;}
 render(animate){const next=this.cards.map((c,i)=>this.distance(i));this.cards.forEach((c,i)=>{const d=next[i],g=this.ghosts[i],gd=this.duplicateDistance(d);if(animate&&this.distances&&Math.abs(d-this.distances[i])>1){this.place(c,this.duplicateDistance(this.distances[i]),false);this.place(g,this.distances[i],false);c.getBoundingClientRect();g.getBoundingClientRect();}this.place(c,d,animate);this.place(g,gd,animate);});this.distances=next;}
 pause(){this.cards.forEach(c=>{const v=c.querySelector('video');if(v){v.pause();v.controls=false;}delete c.dataset.playing;});}
 copy(){this.cards.forEach((c,i)=>{const active=i===this.selected;c.toggleAttribute('data-active',active);c.querySelector('.pfd__select').setAttribute('aria-pressed',String(active));const p=c.querySelector('.pfd__play');if(p)p.tabIndex=active?0:-1;});this.ghosts.forEach(c=>{c.removeAttribute('data-active');c.querySelector('.pfd__select').setAttribute('aria-pressed','false');});const c=this.cards[this.selected];this.heading.textContent=this.selected===this.initial?this.initialHeading:c.dataset.heading;if(this.selected===this.initial)this.text.innerHTML=this.initialText;else this.text.textContent=c.dataset.text;this.stage.setAttribute('aria-label',this.heading.textContent);this.querySelector('.pfd__count').textContent=((this.selected-this.initial+this.count)%this.count+1)+' / '+this.count;}
 move(dir,instant=false){if(this.busy||this.swiped)return;this.pause();this.querySelector('.pfd__status').textContent='';this.selected=(this.selected+dir+this.count)%this.count;this.copy();if(instant||matchMedia('(prefers-reduced-motion: reduce)').matches){this.render(false);return;}this.busy=true;this.render(true);this.timer=setTimeout(()=>this.finish(),230);}
 finish(){clearTimeout(this.timer);if(!this.busy)return;this.busy=false;this.render(false);}
 async play(c){const v=c.querySelector('video');if(!v)return;this.pause();this.querySelector('.pfd__status').textContent='';c.dataset.playing='';v.controls=true;try{await v.play();}catch{delete c.dataset.playing;v.controls=false;this.querySelector('.pfd__status').textContent=this.dataset.error;}}
 disconnectedCallback(){this.pause();clearTimeout(this.timer);this.resize?.disconnect();this.abort?.abort();this.ghosts?.forEach(c=>c.remove());this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pelsfri-faq')) {
  class PelsFriFaq extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.animations = new Map();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-category]');
        if (tab) { this.selectCategory(tab.dataset.category); return; }
        const summary = event.target.closest('summary');
        if (!summary) return;
        event.preventDefault();
        const item = summary.parentElement;
        const opening = !item.open || item.dataset.closing === 'true';
        if (opening) item.parentElement.querySelectorAll('details[open]').forEach(other => { if (other !== item) this.setOpen(other, false); });
        this.setOpen(item, opening);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-category]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[data-category]')];
        const index = tabs.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectCategory(tabs[next].dataset.category);
        tabs[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('details');
        if (!item) return;
        this.selectCategory(item.closest('[data-panel]').dataset.panel);
        this.setOpen(item, true);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.animations?.clear();
    }
    selectCategory(category) {
      this.querySelectorAll('[data-category]').forEach(tab => {
        const selected = tab.dataset.category === category;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== category; });
    }
    setOpen(item, opening) {
      const start = item.getBoundingClientRect().height;
      this.animations.get(item)?.cancel();
      item.style.height = '';
      item.open = true;
      item.dataset.closing = String(!opening);
      const style = getComputedStyle(item);
      const end = opening ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderBottomWidth);
      const finish = () => { item.open = opening; item.style.height = ''; delete item.dataset.closing; this.animations.delete(item); };
      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--pf-duration')) || 200;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) { finish(); return; }
      const animation = item.animate([{height:start+'px'},{height:end+'px'}], {duration, easing:'ease-in-out'});
      this.animations.set(item, animation);
      animation.onfinish = finish;
    }
  }
  customElements.define('pelsfri-faq', PelsFriFaq);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-product-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const setup=(scope=document)=>scope.querySelectorAll('.pf-products--four').forEach(root=>{
  if(root.dataset.mobileArrows)return;root.dataset.mobileArrows='true';
  const track=root.querySelector('.pf-products__track'),prev=root.querySelector('[data-direction="-1"]'),next=root.querySelector('[data-direction="1"]');
  if(!track||!prev||!next)return;
  const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
  [prev,next].forEach(button=>button.addEventListener('click',()=>{
   const slides=[...track.children],max=track.scrollWidth-track.clientWidth;
   const positions=slides.map(slide=>Math.min(max,slide.offsetLeft-slides[0].offsetLeft));
   const current=track.scrollLeft,forward=button.dataset.direction==='1';
   const target=forward?positions.find(position=>position>current+4):positions.reverse().find(position=>position<current-4);
   if(target!==undefined)track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
  }));
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);update();
 });
 setup();document.addEventListener('shopify:section:load',event=>setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-product-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pelsfri-product-faq')) {
  class PelsFriProductFaq extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.animations = new Map();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-category]');
        if (tab) { this.selectCategory(tab.dataset.category); return; }
        const summary = event.target.closest('summary');
        if (!summary) return;
        event.preventDefault();
        const item = summary.parentElement;
        const opening = !item.open || item.dataset.closing === 'true';
        if (opening) item.parentElement.querySelectorAll('details[open]').forEach(other => { if (other !== item) this.setOpen(other, false); });
        this.setOpen(item, opening);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-category]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[data-category]')];
        const index = tabs.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectCategory(tabs[next].dataset.category);
        tabs[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('details');
        if (!item) return;
        this.selectCategory(item.closest('[data-panel]').dataset.panel);
        this.setOpen(item, true);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.animations?.clear();
    }
    selectCategory(category) {
      this.querySelectorAll('[data-category]').forEach(tab => {
        const selected = tab.dataset.category === category;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== category; });
    }
    setOpen(item, opening) {
      const start = item.getBoundingClientRect().height;
      this.animations.get(item)?.cancel();
      item.style.height = '';
      item.open = true;
      item.dataset.closing = String(!opening);
      const style = getComputedStyle(item);
      const end = opening ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderBottomWidth);
      const finish = () => { item.open = opening; item.style.height = ''; delete item.dataset.closing; this.animations.delete(item); };
      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--pf-duration')) || 200;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) { finish(); return; }
      const animation = item.animate([{height:start+'px'},{height:end+'px'}], {duration, easing:'ease-in-out'});
      this.animations.set(item, animation);
      animation.onfinish = finish;
    }
  }
  customElements.define('pelsfri-product-faq', PelsFriProductFaq);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pelsfri-reviews'))customElements.define('pelsfri-reviews',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const opt={signal:this.abort.signal};this.track=this.querySelector('.pfr__track');this.original=[...this.track.children];this.n=this.original.length;if(!this.n)return;this.original.slice(-3).reverse().forEach(x=>this.track.prepend(x.cloneNode(true)));this.original.slice(0,3).forEach(x=>this.track.append(x.cloneNode(true)));this.cards=[...this.track.children];this.cards.forEach((c,i)=>{if(i<3||i>=this.n+3)c.removeAttribute('data-shopify-editor-block')});this.pos=3;this.querySelector('.pfr__prev').addEventListener('click',()=>this.move(-1),opt);this.querySelector('.pfr__next').addEventListener('click',()=>this.move(1),opt);this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.move(e.key==='ArrowLeft'?-1:1)}},opt);this.addEventListener('pointerdown',e=>{this.start={x:e.clientX,y:e.clientY}},opt);this.addEventListener('pointerup',e=>{if(!this.start)return;let dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))this.move(dx<0?1:-1)},opt);this.addEventListener('click',e=>{let b=e.target.closest('.pfr__more');if(!b)return;let open=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(open));b.parentElement.classList.toggle('is-open',open);b.textContent=open?this.dataset.less:this.dataset.more;b.setAttribute('aria-label',b.textContent);this.measure()},opt);this.ro=new ResizeObserver(()=>this.measure());this.ro.observe(this.querySelector('.pfr__carousel'));document.fonts.ready.then(()=>{if(this.isConnected)this.measure()});this.measure()}
 measure(){this.cards.forEach(c=>c.style.minHeight='');this.step=this.cards[0].getBoundingClientRect().width+20;let h=Math.max(...this.cards.map(c=>c.scrollHeight));this.cards.forEach(c=>c.style.minHeight=h+'px');this.paint(false)}
 paint(animate=true){let desktop=matchMedia('(min-width:1024px)').matches;let center=desktop?0:(this.querySelector('.pfr__carousel').clientWidth-this.step+20)/2;this.track.style.transition=animate?'':'none';this.track.style.transform=`translateX(${center-this.pos*this.step}px)`;this.cards.forEach((c,i)=>{let visible=i>=this.pos&&i<this.pos+(desktop?3:1);c.classList.toggle('is-visible',visible);c.inert=!visible;c.setAttribute('aria-hidden',String(!visible))})}
 move(d){if(this.moving)return;this.moving=true;clearTimeout(this.timer);this.pos+=d;this.paint();this.timer=setTimeout(()=>{if(this.pos>=this.n+3)this.pos-=this.n;if(this.pos<3)this.pos+=this.n;this.paint(false);this.moving=false},260)}
 disconnectedCallback(){this.moving=false;this.abort?.abort();this.ro?.disconnect();clearTimeout(this.timer);this.cards?.forEach((c,i)=>{if(i<3||i>=this.n+3)c.remove()});this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pelsfri-stories'))customElements.define('pelsfri-stories',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();let opt={signal:this.abort.signal};this.track=this.querySelector('.pfst__track');this.original=[...this.track.children];this.n=this.original.length;if(!this.n)return;this.original.slice().reverse().forEach(x=>this.track.prepend(x.cloneNode(true)));this.original.forEach(x=>this.track.append(x.cloneNode(true)));this.cards=[...this.track.children];this.cards.forEach((c,i)=>{if(i<this.n||i>=this.n*2)c.removeAttribute('data-shopify-editor-block')});this.pos=this.n;this.addEventListener('click',e=>{let b=e.target.closest('[data-direction]');if(b)this.move(Number(b.dataset.direction))},opt);this.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.move(e.key==='ArrowLeft'?-1:1)}},opt);this.addEventListener('pointerdown',e=>{this.start={x:e.clientX,y:e.clientY}},opt);this.addEventListener('pointerup',e=>{if(!this.start)return;let x=e.clientX-this.start.x,y=e.clientY-this.start.y;this.start=null;if(Math.abs(x)>40&&Math.abs(x)>Math.abs(y))this.move(x<0?1:-1)},opt);this.ro=new ResizeObserver(()=>this.paint(false));this.ro.observe(this.querySelector('.pfst__carousel'));this.paint(false)}
 paint(anim=true){let desktop=matchMedia('(min-width:1024px)').matches,gap=desktop?30:24,w=this.cards[0].getBoundingClientRect().width;this.track.style.transition=anim?'':'none';this.track.style.transform=`translateX(${-this.pos*(w+gap)}px)`;this.cards.forEach((c,i)=>{let yes=i>=this.pos&&i<this.pos+(desktop?3:1);c.inert=!yes;c.setAttribute('aria-hidden',String(!yes))})}
 move(n){if(this.moving)return;this.moving=true;clearTimeout(this.timer);this.pos+=n;this.paint();this.timer=setTimeout(()=>{if(this.pos>=this.n*2)this.pos-=this.n;if(this.pos<this.n)this.pos+=this.n;this.paint(false);this.moving=false},310)}
 disconnectedCallback(){this.moving=false;this.abort?.abort();this.ro?.disconnect();clearTimeout(this.timer);this.cards?.forEach((c,i)=>{if(i<this.n||i>=this.n*2)c.remove()});this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsfri-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pelsfri-videos')) {
  customElements.define('pelsfri-videos', class extends HTMLElement {

    connectedCallback() {
      if (this.abort) return;

      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };

      this.stage = this.querySelector('.pfv__stage');
      if (!this.stage) return;

      this.originals = Array.from(
        this.stage.querySelectorAll('.pfv__card:not([data-clone])')
      );

      this.count = this.originals.length;
      if (!this.count) return;

      this.cards = this.originals;
      this.position = 0;
      this.selected = 0;
      this.edges = [];
      this.inView = false;
      this.autoplayBlocked = false;
      this.geometryDirty = true;
      this.dragged = false;
      this.drag = null;

      /* KOPIER TIL KARRUSELLENS YDERKANter */

      if (this.count === 4) {
        this.originals.forEach((original, i) => {
          const edge = original.cloneNode(true);

          edge.dataset.clone = '';
          edge.dataset.edgeIndex = String(i);

          edge.removeAttribute('data-shopify-editor-block');
          edge.removeAttribute('data-block');

          edge.setAttribute('aria-hidden', 'true');

          edge.querySelectorAll('[id]').forEach(element => {
            element.removeAttribute('id');
          });

          edge.querySelectorAll('a,button').forEach(element => {
            element.tabIndex = -1;
          });

          const video = edge.querySelector('video');

          if (video) {
            video.pause();
            video.autoplay = false;
            video.muted = true;
            video.removeAttribute('autoplay');
          }

          this.stage.append(edge);
          this.edges.push(edge);
        });
      }

      /* NAVIGATION MED KNAPPER */

      this.querySelectorAll('[data-step]').forEach(button => {
        button.addEventListener('click', () => {
          this.go(this.selected - Number(button.dataset.step));
        }, opts);
      });

      /* NAVIGATION MED TASTATUR */

      this.querySelector('.pfv__slider').addEventListener(
        'keydown',
        event => {
          if (
            event.key === 'ArrowRight' ||
            event.key === 'ArrowLeft'
          ) {
            event.preventDefault();

            this.go(
              this.selected +
              (event.key === 'ArrowRight' ? -1 : 1)
            );
          }
        },
        opts
      );

      /* KLIK PÅ VIDEO */

      this.stage.addEventListener('click', event => {
        if (this.dragged && event.detail !== 0) {
          event.preventDefault();
          this.dragged = false;
          return;
        }

        this.dragged = false;

        const card = event.target.closest('.pfv__card');
        if (!card) return;

        const edge = card.dataset.edgeIndex !== undefined;

        const i = edge
          ? Number(card.dataset.edgeIndex)
          : this.cards.indexOf(card);

        const target = edge
          ? Number(card.dataset.target)
          : i + Math.round(
              (this.selected - i) / this.count
            ) * this.count;

        if (event.target.closest('a')) return;

        if (target !== this.selected) {
          this.go(target);
          return;
        }

        if (!edge) {
          this.toggle(card);
        }
      }, opts);

      /* SWIPE OG TRÆK */

      this.stage.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;

        cancelAnimationFrame(this.motionFrame);

        this.dragged = false;
        this.drag = {
          x: event.clientX,
          y: event.clientY,
          start: this.position,
          id: event.pointerId
        };
      }, opts);

      this.stage.addEventListener('pointermove', event => {
        if (!this.drag) return;

        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;

        if (
          !this.dragged &&
          Math.abs(dy) > Math.abs(dx) &&
          Math.abs(dy) > 10
        ) {
          this.drag = null;
          return;
        }

        if (Math.abs(dx) > 8) {
          this.dragged = true;

          if (!this.stage.hasPointerCapture(event.pointerId)) {
            this.stage.setPointerCapture(event.pointerId);
          }

          this.position = this.drag.start - dx / this.cardWidth;

          this.render(false);
        }
      }, opts);

      const end = () => {
        if (!this.drag) return;

        const target = this.dragged
          ? Math.round(this.position)
          : this.selected;

        this.drag = null;

        if (this.dragged) {
          this.go(target);
        }
      };

      this.stage.addEventListener('pointerup', end, opts);
      this.stage.addEventListener('pointercancel', end, opts);

      /* VIDEO-EVENTS */

      this.cards.forEach(card => {
        const video = card.querySelector('video');
        const button = card.querySelector('.pfv__play');

        if (!video) return;

        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = false;

        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        video.removeAttribute('autoplay');

        video.addEventListener('play', () => {
          card.dataset.started = '';
          card.dataset.playing = '';

          if (button) {
            button.setAttribute('aria-label', this.dataset.pause);
          }
        }, opts);

        video.addEventListener('pause', () => {
          delete card.dataset.playing;

          if (button) {
            button.setAttribute('aria-label', this.dataset.play);
          }
        }, opts);

        video.addEventListener('ended', () => {
          delete card.dataset.playing;

          if (button) {
            button.setAttribute('aria-label', this.dataset.play);
          }
        }, opts);
      });

      /* SHOPIFY TEMAEDITOR */

      this.addEventListener('shopify:block:select', event => {
        const id = event.detail.blockId;

        const i = this.originals.findIndex(
          card => card.dataset.block === id
        );

        if (i >= 0) this.go(i);
      }, opts);

      /* RESPONSIVE STØRRELSER */

      this.observer = new ResizeObserver(() => {
        this.geometryDirty = true;
        this.render(false);
      });

      this.observer.observe(this.stage);

      /* AUTOPLAY NÅR SEKTIONEN ER SYNLIG */

      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;

        if (this.inView) {
          this.autoPlayCenter();
        } else {
          this.pauseAll();
        }
      }, {
        threshold: 0.2
      });

      this.visibility.observe(this);

      /* STOP NÅR BROWSERFANEN ER SKJULT */

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAll();
        } else {
          this.autoPlayCenter();
        }
      }, opts);

      window.addEventListener('resize', () => {
        this.geometryDirty = true;
        this.render(false);
      }, opts);

      this.dataset.ready = '';
      this.render(false);
    }

    /* BEREGN KARRUSELLENS PLACERING */

    render() {
      if (!this.count) return;

      if (this.geometryDirty !== false) {
        const desktop = matchMedia('(min-width:1024px)').matches;

        const tablet = matchMedia(
          '(min-width:750px) and (max-width:1023px)'
        ).matches;

        const style = getComputedStyle(this);

        const view = parseFloat(
          style.getPropertyValue(
            desktop ? '--pfv-view' : '--pfv-view-mobile'
          )
        ) || 1.4;

        this.cardWidth = desktop
          ? Math.min(this.stage.clientWidth / view, 340)
          : tablet
            ? Math.min((this.stage.clientWidth - 48) / 2.7, 300)
            : (this.stage.clientWidth - 48) / view;

        this.cardStep = desktop
          ? this.stage.clientWidth / view
          : this.cardWidth;

        this.stage.style.height =
          (this.cardWidth * 16 / 9) + 'px';

        this.depth = desktop ? 1200 / view : 160;

        [...this.cards, ...this.edges].forEach(card => {
          card.style.width = this.cardWidth + 'px';
        });

        this.geometryDirty = false;
      }

      const depth = this.depth;

      this.cards.forEach((card, i) => {
        const virtual = i +
          Math.round(
            (this.position - i) / this.count
          ) * this.count;

        const d = virtual - this.position;

        const scale = 1200 /
          (1200 + Math.abs(d) * depth);

        card.style.visibility =
          Math.abs(d) <= 2.5 ? 'visible' : 'hidden';

        card.style.transitionDuration = '0ms';

        card.style.transform =
          `translateX(calc(-50% + ${d * this.cardStep * scale}px)) scale(${scale})`;

        card.style.opacity = '1';
        card.style.transitionProperty = 'transform';

        card.style.setProperty(
          '--pfv-fade',
          Math.abs(d) <= 1 ? '0' : '.5'
        );

        card.style.zIndex =
          String(20 - Math.round(Math.abs(d)));

        const near = Math.abs(d) <= 2;
        const active = virtual === this.selected;

        card.setAttribute('aria-hidden', String(!near));

        card.querySelectorAll('a,button').forEach(element => {
          element.tabIndex = near ? 0 : -1;
        });

        card.dataset.active = String(active);
      });

      this.edges.forEach((edge, i) => {
        const virtual = i +
          Math.round(
            (this.position - i) / this.count
          ) * this.count;

        const offset = virtual - this.position <= 0
          ? this.count
          : -this.count;

        const d = virtual - this.position + offset;

        const scale = 1200 /
          (1200 + Math.abs(d) * depth);

        edge.style.visibility =
          Math.abs(d) <= 2.5 ? 'visible' : 'hidden';

        edge.style.transitionDuration = '0ms';

        edge.style.transform =
          `translateX(calc(-50% + ${d * this.cardStep * scale}px)) scale(${scale})`;

        edge.style.setProperty('--pfv-fade', '.5');

        edge.style.zIndex =
          String(20 - Math.round(Math.abs(d)));

        edge.dataset.active = 'false';
        edge.dataset.target = String(virtual + offset);
      });
    }

    /* STOP ALLE VIDEOER */

    pauseAll() {
      this.cards?.forEach(card => {
        const video = card.querySelector('video');
        if (video) video.pause();
      });

      this.edges?.forEach(card => {
        const video = card.querySelector('video');
        if (video) video.pause();
      });
    }

    /* AUTOMATISK AFSPILNING AF MIDTERVIDEO */

    autoPlayCenter() {
      if (!this.inView || document.hidden || !this.count) {
        return;
      }

      if (this.autoplayBlocked) return;

      const index =
        ((this.selected % this.count) + this.count) % this.count;

      const card = this.cards[index];
      const video = card?.querySelector('video');

      if (!video) return;

      this.cards.forEach(otherCard => {
        const otherVideo = otherCard.querySelector('video');

        if (otherVideo && otherVideo !== video) {
          otherVideo.pause();
        }
      });

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      if (video.paused) {
        video.play().catch(() => {
          // Browseren kan blokere autoplay.
          // Afspilningsknappen virker stadig manuelt.
        });
      }
    }

    /* SKIFT VIDEO */

    go(index) {
      this.pauseAll();
      this.autoplayBlocked = false;

      cancelAnimationFrame(this.motionFrame);

      this.selected = index;

      const from = this.position;
      const distance = index - from;

      if (
        matchMedia('(prefers-reduced-motion:reduce)').matches ||
        Math.abs(distance) < .001
      ) {
        this.position = index;
        this.render();
        this.autoPlayCenter();
        return;
      }

      const started = performance.now();
      const duration = 360;

      const tick = now => {
        const progress = Math.min(
          1,
          (now - started) / duration
        );

        const eased = 1 - Math.pow(1 - progress, 3);

        this.position = from + distance * eased;
        this.render();

        if (progress < 1) {
          this.motionFrame = requestAnimationFrame(tick);
        } else {
          this.position = index;
          this.render();
          this.autoPlayCenter();
        }
      };

      this.motionFrame = requestAnimationFrame(tick);
    }

    /* MANUEL AFSPIL / PAUSE */

    async toggle(card) {
      const video = card.querySelector('video');

      if (!video) return;

      if (!video.paused) {
        this.autoplayBlocked = true;
        video.pause();
        return;
      }

      this.autoplayBlocked = false;
      this.pauseAll();

      const status = this.querySelector('.pfv__status');
      if (status) status.textContent = '';

      video.muted = true;

      try {
        await video.play();
      } catch {
        if (status) {
          status.textContent = this.dataset.error;
        }
      }
    }

    /* OPRYDNING */

    disconnectedCallback() {
      cancelAnimationFrame(this.motionFrame);

      this.pauseAll();

      this.abort?.abort();
      this.abort = null;

      this.observer?.disconnect();
      this.visibility?.disconnect();

      this.querySelectorAll('[data-clone]').forEach(card => {
        card.remove();
      });

      delete this.dataset.ready;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
